// extracted by mini-css-extract-plugin
export default {"logo":"DxAJby8bNpukx5D6wtzS2g==","background":"u+MgMFlwwxmo05T4ytOgkA=="};